import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useConsultarFatura } from "../../../hooks/queries/pagamento/useConsultarFatura/useConsultarFatura";
import { useDownloadRecibo } from "../../../hooks/queries/agendamento/useDownloadRecibo/useDownloadRecibo";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { StatusPagamentoEnum } from "../../../enums/statusPagamento";
import { reverseToBrDate } from "../../../utils/dateTransform";
import { IEnderecoDTO } from "../../../types/endereco";
import { Tracking } from "../../../services/Tracking";
import { useUserPermissions } from "../../../hooks/useUserPermissions";

function formatEndereco(endereco?: IEnderecoDTO) {
  if (!endereco) return undefined;

  const { logradouro, numero, bairro, cidade, uf } = endereco;
  return [logradouro, numero, bairro, `${cidade}/${uf}`]
    .filter(Boolean)
    .join(", ");
}

export const useConfirmAppointmentV2 = () => {
  const { uuidAgendamento } = useParams();
  const navigate = useNavigate();
  const stepIndicator = useAgendamentoStepIndicator();
  const { isUserType } = useUserPermissions();
  const isCustomsBroker = isUserType("DESPACHANTE");

  const { data: agendamento } = useAgendamentoPorId(uuidAgendamento ?? "");
  const { data: fatura } = useConsultarFatura(uuidAgendamento ?? "");
  const { mutate: downloadRecibo, isPending: isBaixandoRecibo } =
    useDownloadRecibo();

  const pagamento = fatura?.content?.find(
    (f) =>
      f.status === StatusPagamentoEnum.paid ||
      f.status === StatusPagamentoEnum.pending,
  );

  const localNome = agendamento?.loja?.nome;
  const localEndereco = formatEndereco(agendamento?.loja?.endereco);

  function handleBaixarChecklist() {
    Tracking.userAction(
      "mapa:agendamento/confirmar-agendamento:clique-baixar-checklist",
    );
  }

  function handleBaixarRecibo() {
    if (!uuidAgendamento || !pagamento?.uuid) return;

    Tracking.userAction(
      "mapa:agendamento/confirmar-agendamento:clique-baixar-recibo",
    );

    downloadRecibo({ uuidAgendamento, uuidFatura: pagamento.uuid });
  }

  const isReciboIndisponivel = !pagamento?.uuid;

  function handleVerMeusAgendamentos() {
    Tracking.userAction(
      "mapa:agendamento/confirmar-agendamento:clique-ver-meus-agendamentos",
    );
    navigate("/meus-agendamentos");
  }

  function handleVoltarAoInicio() {
    Tracking.userAction(
      "mapa:agendamento/confirmar-agendamento:clique-voltar-ao-inicio",
    );

    const path = isCustomsBroker ? "/agendamento/inicio" : "/";
    navigate(path);
  }

  return {
    stepIndicator,
    dataHoraLabel:
      agendamento?.diaAgendado && agendamento?.horaAgendada
        ? `${reverseToBrDate(agendamento.diaAgendado)} às ${agendamento.horaAgendada}`
        : undefined,
    localNome,
    localEndereco,
    servico: agendamento?.servico?.nome,
    veiculoModelo: agendamento?.veiculo?.modelo,
    veiculoPlaca: agendamento?.veiculo?.placa,
    valorPago: pagamento?.valorTotal,
    checklistHref: `/assets/docs/checklist-${process.env.REACT_APP_PROJECT}.pdf`,
    isBaixandoRecibo,
    isReciboIndisponivel,
    handleBaixarChecklist,
    handleBaixarRecibo,
    handleVerMeusAgendamentos,
    handleVoltarAoInicio,
  };
};
